import React, { useState, useEffect } from "react";
import { makeStyles } from "@mui/styles";
import {
  Button,
  Card,
  CardContent,
  FormHelperText,
  Grid,
  TextField,
} from "@mui/material";
import { callAPI } from "../../../../../App/Helpers/callApi";
import LoadingBar from "../../../../../App/Components/LoadingBar/LoadingBar";
import {
  AddLocation,
  getCoords,
  getCountries,
  getLocations,
} from "../../../LocationsService";
import { basicSort } from "../../../../../App/Helpers/BasicSort";
import DropdownSearch from "../../../../../App/Components/Dropdown/DropdownSearch";

const useStyles = makeStyles((theme) => ({
  root: {
    [theme.breakpoints.down("md")]: {
      width: "100%",
    },
    justifyContent: "space-between",
    width: "100%",
    display: "flex",
    flexDirection: "column",
  },
  error: {
    color: theme.palette.error.main,
  },
}));
export default function AddLocationModal({
  openModal,
  clientId,
  setShowSignifier,
  setResponseMessage,
  setShowError,
  setTableData,
}) {
  const classes = useStyles();
  const [processing, setProcessing] = useState(false);
  const [inputError, setInputError] = useState(false);

  const [name, setName] = useState("");
  const [number, setNumber] = useState("");
  const [brand, setBrand] = useState("");
  const [address1, setAddress1] = useState("");
  const [address2, setAddress2] = useState("");
  const [address3, setAddress3] = useState("");
  const [postalCode, setPostalCode] = useState("");
  const [longitude, setLongitude] = useState("");
  const [latitude, setLatitude] = useState("");
  const [pageURL, setPageURL] = useState("");
  const [newCityName, setNewCityName] = useState("");

  const [countries, setCountries] = useState([]);
  const [divisons, setDivisions] = useState([]);
  const [cities, setCities] = useState([]);

  const [selectedCountry, setSelectedCountry] = useState({});
  const [selectedDivision, setSelectedDivision] = useState({});
  const [selectedCity, setSelectedCity] = useState({});

  const checkEntered = () => {
    if (
      name === "" ||
      postalCode === "" ||
      address1 === "" ||
      selectedCity?.name === undefined ||
      selectedCountry?.name === undefined ||
      selectedDivision?.name === undefined
    ) {
      return false;
    }
    if (selectedCity?.name === "+ Add New City" && newCityName === "") {
      return false;
    }
    return true;
  };

  function addGroup() {
    if (!checkEntered()) {
      setInputError(true);
      return;
    }

    let json = {
      ClientId: clientId,
      CityID: selectedCity.id,
      DivisionID: selectedDivision.id,
      CountryID: selectedCountry.id,
      Name: name,
      City:
        selectedCity?.name === "+ Add New City" ||
        selectedCity?.name === undefined
          ? newCityName
          : selectedCity.name,
      StoreNumber: number,
      Brand: brand,
      AddressLine1: address1,
      AddressLine2: address2,
      AddressLine3: address3,
      CityAbbreviation: selectedCity?.Abbreviation,
      DivisionAbbreviation: selectedDivision?.Abbreviation,
      CountryName: selectedCountry?.name,
      CountryAbbreviation: selectedCountry?.Abbreviation,
      CountryCode: selectedCountry?.Code,
      ZipCode: postalCode,
      Longitude: longitude,
      Latitude: latitude,
      LocationPage: pageURL,
    };

    callAPI(
      AddLocation(json),
      "Location Added",
      setShowSignifier,
      setResponseMessage,
      setShowError,
      setProcessing
    ).then(() => {
      getLocations(clientId).then((response) => {
        setTableData(response);
        openModal(false);
      });
    });
  }

  function addCoords() {
    if (
      selectedCountry?.name === undefined ||
      selectedDivision?.name === undefined ||
      selectedCity?.name === undefined
    ) {
      alert("Please enter Country, Division, and City");
      return;
    }

    if (selectedCity?.name === "+ Add New City" && newCityName === "") {
      alert("Please enter Country, Division, and City");
      return;
    }

    var reqAdd = address1 === "" ? " " : address1;
    var reqPostCode = postalCode === "" ? " " : postalCode;
    var reqCity =
      selectedCity?.name === "+ Add New City" ? newCityName : selectedCity.name;
    getCoords(reqAdd, reqCity, selectedDivision.name, reqPostCode).then(
      (response) => {
        setLatitude(response.key);
        setLongitude(response.value);
      }
    );
  }

  useEffect(() => {
    getCountries().then((response) => {
      response.sort((a, b) => {
        const order = basicSort(a.name, b.name);
        if (order !== 0) return order;
        return a[1] - b[1];
      });
      setCountries(response);
    });
  }, []);

  useEffect(() => {
    if (selectedCountry?.divisions !== undefined) {
      selectedCountry.divisions.sort((a, b) => {
        const order = basicSort(a.name, b.name);
        if (order !== 0) return order;
        return a[1] - b[1];
      });
    }
    setDivisions(
      selectedCountry?.divisions === undefined ? [] : selectedCountry.divisions
    );
  }, [selectedCountry]);

  useEffect(() => {
    if (selectedDivision?.cities !== undefined) {
      selectedDivision.cities.sort((a, b) => {
        const order = basicSort(a.name, b.name);
        if (order !== 0) return order;
        return a[1] - b[1];
      });
    }
    setCities(
      selectedDivision?.cities === undefined
        ? [{ name: "+ Add New City" }]
        : [{ name: "+ Add New City" }].concat(selectedDivision.cities)
    );
  }, [selectedDivision]);

  useEffect(() => {
    setNewCityName("");
  }, [selectedCity]);

  return (
    <div className={classes.root}>
      <LoadingBar loading={processing} />
      <Grid>
        <Card>
          <CardContent>
            <FormHelperText style={{ fontWeight: "bold" }}>
              Add Location
            </FormHelperText>
            <Grid container spacing={1}>
              <Grid item xs={12} sm={4}>
                <TextField
                  placeholder="Name"
                  label="Name"
                  variant="standard"
                  fullWidth
                  required
                  value={name}
                  error={inputError && name === ""}
                  onChange={(e) => setName(e.target.value)}
                />
                {inputError && name === "" && (
                  <FormHelperText className={classes.error}>
                    Name Required
                  </FormHelperText>
                )}
              </Grid>
              <Grid item xs={12} sm={4}>
                <TextField
                  placeholder="Number"
                  label="Number"
                  variant="standard"
                  fullWidth
                  required
                  value={number}
                  onChange={(e) => setNumber(e.target.value)}
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <TextField
                  placeholder="Brand"
                  label="Brand"
                  variant="standard"
                  fullWidth
                  required
                  value={brand}
                  onChange={(e) => setBrand(e.target.value)}
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <TextField
                  placeholder="Address Line 1"
                  label="Address Line 1"
                  variant="standard"
                  fullWidth
                  required
                  error={inputError && address1 === ""}
                  value={address1}
                  onChange={(e) => setAddress1(e.target.value)}
                />
                {inputError && address1 === "" && (
                  <FormHelperText className={classes.error}>
                    Address Required
                  </FormHelperText>
                )}
              </Grid>
              <Grid item xs={12} sm={4}>
                <TextField
                  placeholder="Address Line 2"
                  label="Address Line 2"
                  variant="standard"
                  fullWidth
                  required
                  value={address2}
                  onChange={(e) => setAddress2(e.target.value)}
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <TextField
                  placeholder="Address Line 3"
                  label="Address Line 3"
                  variant="standard"
                  fullWidth
                  required
                  value={address3}
                  onChange={(e) => setAddress3(e.target.value)}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <DropdownSearch
                  items={countries}
                  property="name"
                  title="Countries"
                  handleChange={(value) => setSelectedCountry(value)}
                  currValue={selectedCountry}
                  error={inputError && selectedCountry?.name === undefined}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <DropdownSearch
                  items={divisons}
                  property="name"
                  title="Division"
                  handleChange={(value) => setSelectedDivision(value)}
                  currValue={selectedDivision}
                  error={inputError && selectedDivision?.name === undefined}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <DropdownSearch
                  items={cities}
                  property="name"
                  title="Cities"
                  handleChange={(value) => setSelectedCity(value)}
                  currValue={selectedCity}
                  error={
                    (inputError && selectedCity?.name === undefined) ||
                    (inputError &&
                      selectedCity?.name === "+ Add New City" &&
                      newCityName === "")
                  }
                />
              </Grid>
              {selectedCity?.name === "+ Add New City" ? (
                <Grid item xs={12} sm={6}>
                  <TextField
                    placeholder="New City Name"
                    label="New City Name"
                    variant="standard"
                    fullWidth
                    aria-required
                    error={inputError && newCityName === ""}
                    value={newCityName}
                    onChange={(e) => setNewCityName(e.target.value)}
                  />
                  {inputError && newCityName === "" && (
                    <FormHelperText className={classes.error}>
                      City Required
                    </FormHelperText>
                  )}
                </Grid>
              ) : null}
              <Grid item xs={12} sm={12}>
                <TextField
                  placeholder="Postal Code"
                  label="Postal Code"
                  variant="standard"
                  fullWidth
                  required
                  error={inputError && postalCode === ""}
                  value={postalCode}
                  onChange={(e) => setPostalCode(e.target.value)}
                />
                {inputError && postalCode === "" && (
                  <FormHelperText className={classes.error}>
                    Postal Code Required
                  </FormHelperText>
                )}
              </Grid>
              <Grid item xs={12} sm={4}>
                <TextField
                  placeholder="Latitude"
                  label="Latitude"
                  variant="standard"
                  fullWidth
                  required
                  value={latitude}
                  onChange={(e) => setLatitude(e.target.value)}
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <TextField
                  placeholder="Longitude"
                  label="Longitude"
                  variant="standard"
                  fullWidth
                  required
                  value={longitude}
                  onChange={(e) => setLongitude(e.target.value)}
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <Button
                  style={{ marginTop: "10px" }}
                  type="submit"
                  variant="contained"
                  color="primary"
                  fullWidth
                  onClick={() => addCoords()}
                >
                  {" "}
                  Get Coordinates
                </Button>
              </Grid>
              <Grid item xs={12} sm={12}>
                <TextField
                  placeholder="Location's Page URL"
                  label="Location's Page URL"
                  variant="standard"
                  fullWidth
                  required
                  value={pageURL}
                  onChange={(e) => setPageURL(e.target.value)}
                />
              </Grid>
              <Grid
                container
                justifyContent="flex-end"
                direction="row"
                style={{ marginRight: "10px" }}
              >
                <Grid item xs={6} sm={3}>
                  <Button
                    style={{ color: "#82B288", marginTop: "20px" }}
                    type="submit"
                    variant="outlined"
                    fullWidth
                    onClick={() => openModal(false)}
                  >
                    Cancel
                  </Button>
                </Grid>
                <Grid item xs={6} sm={3}>
                  <Button
                    style={{ marginTop: "20px", marginLeft: "10px" }}
                    type="submit"
                    variant="contained"
                    color="primary"
                    fullWidth
                    onClick={() => addGroup()}
                  >
                    Save
                  </Button>
                </Grid>
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      </Grid>
    </div>
  );
}
